import { BulbOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useUser } from 'src/context/UserContext'
import { StorageKey } from 'src/util/Storage'
import { adminTabs, demandTabs, supplyTabs } from '../../../constants/sidebarTabs'
import ProfileMenu from './ProfileMenu'
import './style.css'

export const Breadcrumb: React.FC = () => {

    const [breadcrumb, setBreadcrumb] = useState<any>([])

    const location = useLocation()
    const { blackTheme, setBlackTheme } = useUser()

    const sidebarTabs = [...supplyTabs, ...demandTabs, ...adminTabs]

    const getBreadcrumb = () => {
        const path = location.pathname.substring(1)
        const pathName: string = path.split('/')[0]

        if (path.includes('edit')) {
            return (
                <span key={'edit'}>
                    <span>{getItemName(pathName)}</span>
                    <span className="breadcrumbBar__arrow" />
                    <strong>Edit</strong>
                </span>
            )
        } else if (path.includes('create')) {
            return (
                <span key={'create'}>
                    <span>{getItemName(pathName)}</span>
                    <span className="breadcrumbBar__arrow" />
                    <strong>Create</strong>
                </span>
            )
        } else if (path.includes('view')) {
            return (
                <span key={'view'}>
                    <span className="breadcrumbBar__arrow" />
                    <span>{getItemName(pathName)}</span>
                    <span className="breadcrumbBar__arrow" />
                    <strong>View</strong>
                </span>
            )
        } else {
            return (
                <span key={'default'}>
                    <strong>{getItemName(pathName)}</strong>
                </span>
            )
        }
    }

    const getItemName = (pathname: string) => {
        let menuName: string = 'Campaign'
        sidebarTabs.map(item => {
            const { name, key } = item
            if (key?.localeCompare(pathname) == 0) {
                menuName = name
            }
        })
        return menuName
    }

    useEffect(() => {
        setBreadcrumb(getBreadcrumb())
    }, [location])

    const handleThemeChange = () => {
        localStorage.setItem(StorageKey.BlackThemeEnabled, !blackTheme ? 'true' : 'false')
        setBlackTheme(!blackTheme)
    }

    return (
        <div className={`breadcrumbBar ${blackTheme ? 'breadcrumb_black' : 'breadcrumb_white'}`}>
            <div className={`breadcrumbBar__path ${blackTheme ? 'breadcrumbBar__path_black' : 'breadcrumbBar__path_white'}`} style={{ display: 'inline-block' }} >
                {breadcrumb}
            </div>
            <div className="breadcrumbBar__profile">
                <Button type="text" onClick={handleThemeChange}>
                    <BulbOutlined />
                </Button>
                <ProfileMenu />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/component/app/breadcrumb/Breadcrumb.tsx